
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';
import MaskedInput from 'react-text-mask';
import { Grid, InputAdornment } from '@material-ui/core';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
        placeholderChar={'\u2000'}
        showMask
      />
    );
  }

  TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
  };

  function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        // thousandSeparator
        isNumericString
        prefix=""
      />
    );
  }
  
  NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  function NumberZeroFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
  
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={values => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        // thousandSeparator
        allowLeadingZeros
        isNumericString
        prefix=""
      />
    );
  }
  
  NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  };

const RenderDecimalTextField = (props) => {
    const { input, label, type, meta: { touched, error }, disabled , simbol, allowZero, changeData, onKeyPress, autoFocus, color} = props
    /*const [values, setValues] = useState({
        numberformat: '' + valueData ,
    }); */
    const handleChange = name => event => {
          changeData && changeData(event.target.value)
    };
        return <div>
                  <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
                    <Grid item xs={12} md={12}>
                      <span style={{color:'white'}}>{label}</span>
                    </Grid>
                  </Grid>
                    <TextField
                        {...input}
                        type={!type ? "text" : type}
                        margin="none"
                        fullWidth
                        name={label}
                        style={{backgroundColor: 'white'}}
                        label={''}
                        variant="outlined"
                        onChange={handleChange('numberformat')}
                        disabled = {disabled}
                        autoFocus = {autoFocus}
                        InputLabelProps= {
                          {
                            style: { color }
                          }
                        }
                        InputProps={{
                          inputComponent: (allowZero ? NumberZeroFormatCustom : NumberFormatCustom ),
                          startAdornment: <InputAdornment position="start">{simbol ? simbol : ''}</InputAdornment>,
                        }}
                        onKeyPress={ onKeyPress }
                        autoComplete ='off'
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                    {touched && error && <span style = {{ color: 'red'}}>{error}</span>}
                </div>
}
    

/* renderDecimalTextField.propTypes = {
     
}; */

export default RenderDecimalTextField;